import React, { useEffect, useState } from 'react'
import { Card, Button, Col, Form, Modal, notification, Row, Spin, Tooltip, message } from 'antd'
import { CiSquarePlus } from 'react-icons/ci'
import { DeleteOutlined, EditOutlined, SelectOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import { roleService } from '../../../../services';
import RoleModal from './Modal';

function Role() {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [isModalShow, setIsModalShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false)
    const [roles, setRoles] = useState([])
    const [id, setID] = useState(null)
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState(null);

    const handleCancel = () => {
        form.resetFields()
        setEditData(null)
        setID(null)
        setIsModalShow(false);
        setDeleteModal(false)
    };

    const handleOk = async () => {

        const getRole = roles.find(role => role.id === id);

        if (getRole.users_count > 0) {
            message.error("Role cannot be deleted as it has users assigned.");
            setDeleteModal(false)
            return;
        }

        setDeleteLoading(true)
        const response = await roleService.delete(id)
        setDeleteLoading(false)
        if (response?.success ?? false) {
            notification.success({ message: "Role deleted Successfully." })
            initialize();
            setID(null)
        }
        setDeleteModal(false)
    }

    const onFinish = async (values) => {
        setSubmitLoading(true)
        const response = isEdit ? await roleService.edit(id, values) : await roleService.add(values);
        setSubmitLoading(false)
        if (response?.success ?? false) {
            notification.success({
                message: isEdit ? "Role Updated Successfully." : "Role Added Successfully."
            })
            handleCancel();
            initialize();
        }
    }

    const handleAdd = () => {
        setIsEdit(false)
        setEditData(null)
        setIsModalShow(true)
    }

    const handleEdit = async (id) => {
        setID(id)
        setIsEdit(true)
        setEditData(roles.find(role => role.id === id))
        setIsModalShow(true)
    }

    const handleDelete = (id) => {
        setID(id)
        setDeleteModal(true)
    }

    const initialize = async () => {
        setLoading(true)
        const { success, data } = await roleService.fetch()
        setLoading(false)
        if (success) {
            setRoles(data)
        }
    }

    useEffect(() => {
        initialize()
    }, [])

    return (
        <div>
            <Row gutter={24} style={{ border: "1px solid #D9D9D9", display: 'flex', alignItems: "center", backgroundColor: "#FFFFFF", padding: "12px", borderRadius: "8px" }}>
                <Col span={12} style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    Manage Roles
                </Col>
                <Col span={12} style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}>
                    <Button type="primary" onClick={handleAdd} > Add Roles </Button>
                    {/* <CiSquarePlus size={26} style={{ cursor: "pointer" }} /> */}
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: "25px" }}>
                {loading ?
                    <div className="flex justify-center min-w-full min-h-[50vh] items-center">
                        <Spin spinning={loading} size={"large"} tip="Loading..." />
                    </div>
                    :
                    <>
                        {roles?.slice().sort((a, b) => b.id - a.id).map((data, index) => (
                            <Col xs={24} sm={12} md={8} lg={6} xl={6} >
                                <Card
                                    style={{
                                        width: "100%",
                                        // maxWidth: "250px",
                                        borderRadius: "12px",
                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                        textAlign: "center",
                                    }}
                                    actions={[
                                        <div>
                                            <Tooltip title='Assign Permissions'>
                                                <SelectOutlined key='assign' onClick={() => navigate(`/staff/role/permissions/${data.id}`)} />
                                            </Tooltip>
                                        </div>,
                                        <div>
                                            <Tooltip title="Edit" onClick={() => handleEdit(data.id)}>
                                                <EditOutlined key="edit" />
                                            </Tooltip>
                                        </div>,
                                        <div >
                                            <Tooltip title='Delete'>
                                                <DeleteOutlined key="delete" onClick={() => handleDelete(data.id)} />
                                            </Tooltip>
                                        </div>,
                                    ]}
                                >
                                    <div
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            marginBottom: "15px",
                                            marginRight: "auto",
                                            marginLeft: "auto",
                                        }}
                                    >
                                        <img
                                            src="/images/img1.png"
                                            alt="User"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                    {/* Roles */}
                                    <div style={{ marginTop: 16, fontWeight: "bold", fontSize: "16px" }}>
                                        {/* <UserOutlined style={{ marginRight: 8 }} /> */}
                                        {data.title}
                                    </div>

                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}>
                                        <p style={{ fontSize: "14px",marginTop: 10, }}>
                                            Users for this role
                                        </p>
                                        <p style={{ fontSize: "22px", fontWeight: "bold" }}>
                                            {data.users_count.toString().padStart(2, '0')}
                                        </p>
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </>
                }

            </Row>
            {/* add/edit role modal */}
            <RoleModal
                isModalShow={isModalShow}
                handleCancel={handleCancel}
                onFinish={onFinish}
                submitLoading={submitLoading}
                edit={isEdit}
                initialValues={editData}
            />

            {/* delete modal */}
            <Modal
                title={<div style={{ textAlign: "center" }}>Confirm</div>}
                open={deleteModal}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                style={{
                    padding: "20px",
                }}
                width={300}
                footer={
                    <div className="flex justify-center gap-3">
                        <Button
                            type="default"
                            onClick={handleCancel}
                            style={{ width: "30%" }}
                        >
                            Cancel
                        </Button>
                        <Button type="primary" onClick={handleOk} style={{ width: "30%" }} loading={deleteLoading}>
                            Confirm
                        </Button>
                    </div>
                }
            >
                <p style={{ textAlign: "center" }}>
                    Are you sure you want to delete this role?
                </p>
            </Modal>
        </div>
    )
}

export default Role
